// extracted by mini-css-extract-plugin
export var container = "_31-0";
export var error = "_31-9";
export var label = "_31-5";
export var light = "_31-6";
export var md = "_31-3";
export var sm = "_31-2";
export var thin = "_31-8";
export var thinBold = "_31-7";
export var vertical = "_31-4";
export var xs = "_31-1";